import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import moment from 'moment';

import { cilChevronBottom } from '@coreui/icons';

import DAaddPartnerModal from 'src/components/Modals/DAaddPartnerModal';
import TermsAndConditionModal from 'src/components/Modals/TermsAndConditionModal';
import ConfirmationModal from '../../components/Modals/ConfirmationModal';

import { formValidator } from 'src/helpers/formValidator';

import CustomDatagrid from 'src/components/DataGridComponents/CustomDatagrid';
import DataGridHeader from 'src/components/DataGridComponents/DataGridHeader';

import {
  getDaDspsRegisterInputs,
  getInitialDspData,
} from 'src/configs/InputConfig/daDspsRegConfig';

import { CFormCheck } from '@coreui/react';
import Inputs from 'src/components/Filters/Inputs';
import AppContainer from 'src/components/UI/AppContainer';
import Form from 'src/components/UI/Form';
import Loading from 'src/components/UI/Loading';
import { getDspPartnersCols } from 'src/configs/ColumnsConfig/dspPartnersCols';
import { useCreatePartners } from 'src/hooks/api/useCreatePartners';
import { useFetchPartners } from 'src/hooks/api/useFetchPartners';
import { useRegisterDsp } from 'src/hooks/api/useRegisterDsp';
import { useUploadAvatar } from 'src/hooks/api/useUploadAvatar';
import useEmailVerification from 'src/hooks/useEmailVerification';
import { useShowConfirmation } from 'src/hooks/useShowConfirmation';
import { useShowSnackbar } from 'src/hooks/useShowSnackbar';
import { useShowToast } from 'src/hooks/useShowToast';

const DADspRegister = () => {
  // let state;
  const location = useLocation();
  const user = useSelector((state) => state.user);
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const showSnackbar = useShowSnackbar();

  const showToast = useShowToast();
  const navigate = useNavigate();
  const showConfirmation = useShowConfirmation();

  const { loading: partnersLoading, fetchPartners } = useFetchPartners();
  const { uploadAvatar } = useUploadAvatar();
  const { createUpdateDsp, loading } = useRegisterDsp();
  const { createPartners } = useCreatePartners();
  const { checkEmailValidation } = useEmailVerification();

  useEffect(() => {
    const state = location.state;
    formValidator();
    if (state !== null) {
      const daDsps = state.user;
      const daInitialData = {
        ...daDsps,
        isWhatsappAsso: daDsps.whatsApp === '' || daDsps.whatsApp === null ? false : true,
        country: daDsps.stateId && daDsps.stateId < 54 ? 1 : 2,
      };
      setDspRegData(daInitialData);
      getPartnerList(daDsps.id);
    }
  }, [location.state]);

  const [dspRegData, setDspRegData] = useState(getInitialDspData(user));
  const [rows, setRows] = useState([]);
  const [showForm, setShowForm] = useState(true);
  const [addPartnerModalOpen, setModalOpen] = useState(false);
  const [termsModalOpen, setTermsModalOpen] = useState(false);
  // const { createUpdateDsp, createUpdateDspdata } = useRegisterDsp();
  const [showPartners, setShowPartners] = useState(true);
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [emailMessage, setEmailMessage] = useState('Enter Valid Email Address');

  const getPartnerList = async (id) => {
    const partnerList = await fetchPartners(id);
    const mappedArray = partnerList.map((data, index) => ({
      uid: data.id,
      businessName: data.businessName,
      rowVer: 1,
      createdAt: data.createdAt,
      lastUpdatedAt: moment().utc().format(0),
      fullName: data.fullName,
      primaryContact: data.primaryContact,
      dob: data.dob,
      email: data.email,
      status: data.status,
      createdBy: data.createdBy,
      decisionMakingAuthority: data.decisionMakingAuthority,
    }));
    setRows(mappedArray);
  };

  const handleSuccess = (message) => {
    showToast(message || 'DSP Registered Successfully');
    navigate(isAuthenticated ? '/DspsList' : '/');
  };

  const submitDsp = async (logoPath = null) => {
    const res = await createUpdateDsp({
      ...dspRegData,
      ...(logoPath && { logoPath }),
      WhatsApp: dspRegData.isWhatsappAsso ? dspRegData.contact : '',
    });

    if (res?.status === true) {
      rows.length > 0 ? createPartnerData(res.data.id) : handleSuccess(res?.message);
    }
  };

  const registerDsp = async () => {
    const form = document.querySelector('.dsp-reg-form');
    formValidator();
    if (!form.checkValidity()) return;

    const fileInput = document.getElementById('fileAvatar');
    const avatar = fileInput.files?.[0];

    if (avatar) {
      const formData = new FormData();
      formData.append('file', avatar);
      formData.append('id', '0');
      formData.append('name', avatar.name);
      formData.append('fileName', avatar.name);
      formData.append('createdBy', user.userId || 0);
      formData.append('createdAt', moment().utc().format());

      const uploadAvatarRes = await uploadAvatar(formData);
      if (uploadAvatarRes.status === true) {
        const logoPath = 'productimages/' + uploadAvatarRes.keyValue.toString().split('\\').pop();
        await submitDsp(logoPath);
      }
    } else {
      await submitDsp();
    }
  };

  const createPartnerData = async (dspId) => {
    const updatedRows = rows.map(({ uid, ...rest }) => ({
      ...rest,
      id: uid,
      dspid: dspId,
      lastUpdatedBy: user.userId || 0,
      createdBy: rest.createdBy || 0,
    }));

    const res = await createPartners(updatedRows);
    if (res?.status === true) handleSuccess(res?.message);
  };

  const handleDspRegForm = (e, label) => {
    if (label === 'logoPath') {
      setDspRegData((prevData) => ({ ...prevData, [label]: e }));
    } else {
      const { name, value, type, checked } = e.target;
      const updatedValue = type === 'checkbox' ? checked : value;

      // ✅ Mailing Address: block emails
      if (name === 'address' && updatedValue.includes('@')) {
        showSnackbar('Mailing address cannot contain an email address', 'warning');
        setDspRegData((prevData) => ({ ...prevData, [name]: '' })); // clear field
        return; // do not save
      }

      setDspRegData((prevData) => ({
        ...prevData,
        [name]: updatedValue,
      }));
    }
  };

  const onBlur = async () => {
    let fieldValue = dspRegData.email?.trim(); // Remove spaces
    const emailInputElement = document.getElementById('email');

    // 🚫 Skip validation if empty
    if (!fieldValue) {
      setEmailMessage('');
      emailInputElement.setCustomValidity('');
      return;
    }

    // ✅ Simplified + flexible regex (handles .com.pk, .co.uk, etc.)
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}(?:\.[A-Za-z]{2,})?$/;

    if (!emailRegex.test(fieldValue)) {
      showToast(`${fieldValue} is not a valid email`, 'error');
      setEmailMessage(`${fieldValue} is not a valid email`);
      emailInputElement.setCustomValidity(`${fieldValue} is not a valid email`);
      return;
    } else {
      emailInputElement.setCustomValidity('');
    }

    // ✅ Async email verification (only if not empty and regex passed)
    const isValidEmail = await checkEmailValidation(fieldValue);
    if (isValidEmail === null || isValidEmail === 'valid') {
      emailInputElement.setCustomValidity('');
      setEmailMessage('');
    } else if (isValidEmail === 'invalid') {
      showToast(`${fieldValue} is not a valid email`, 'error');
      setEmailMessage(`${fieldValue} is not a valid email`);
      emailInputElement.setCustomValidity(`${fieldValue} is not a valid email`);
    }
  };

  const AddPartnerClick = () => {
    toggleAddPartMdl(true);
  };

  const toggleAddPartMdl = () => {
    setModalOpen(!addPartnerModalOpen);
  };

  const toggleStock = () => {
    setShowForm((prev) => !prev);
  };

  const toggleLicense = () => {
    setShowPartners(!showPartners);
  };

  const TermsModal = () => {
    setTermsModalOpen(!termsModalOpen);
  };
  const confirmationModal = () => {
    setConfirmationModalOpen(!confirmationModalOpen);
  };
  const goToAnotherPage = () => {
    if (!isAuthenticated) {
      showConfirmation({
        isOpen: false,
      });
      navigate('/');
    } else {
      navigate('/DspsList');
    }
  };

  const dspPartnersCols = getDspPartnersCols(setRows, rows);
  const daDspsRegisterInputs = getDaDspsRegisterInputs(
    dspRegData,
    handleDspRegForm,
    TermsModal,
    emailMessage,
    onBlur,
  );

  return (
    <Form name="dsp-reg-form">
      <AppContainer>
        <DataGridHeader
          title=" DSP Basic Information"
          otherControls={[{ icon: cilChevronBottom, fn: toggleStock }]}
          filterDisable={true}
        />
        {(partnersLoading || loading) && <Loading />}

        {showForm && (
          <React.Fragment>
            <Inputs
              inputFields={daDspsRegisterInputs}
              yesFn={goToAnotherPage}
              submitFn={registerDsp}
            >
              <div className="d-flex flex-column mt-2">
                <DataGridHeader
                  title={`Partners (${rows.filter((item) => item.status !== 6).length})`}
                  addButton={'Add Partner'}
                  addBtnClick={AddPartnerClick}
                  otherControls={[{ icon: cilChevronBottom, fn: toggleLicense }]}
                />
                {showPartners && (
                  <div style={{ width: '100%', height: rows.length == 0 ? 400 : 'auto' }}>
                    <CustomDatagrid
                      rows={rows}
                      columns={dspPartnersCols}
                      pagination={true}
                      rowHeight={40}
                      pageNumber={5}
                      noRowsMessage="0 partners"
                      autoHeight={rows.length > 0 ? true : false}
                    />
                  </div>
                )}
              </div>
              <CFormCheck
                name="isTermsAccepted"
                checked={dspRegData.isTermsAccepted}
                onChange={handleDspRegForm}
                className="d-flex flex-row justify-content-center mt-1"
                id="isTermsAccepted"
                required
                label={
                  <span>
                    By providing this info, you agree to our terms & conditions, read our{' '}
                    <strong className="lblTerms" onClick={TermsModal}>
                      Terms & Conditions (EULA)
                    </strong>
                  </span>
                }
              />
            </Inputs>
          </React.Fragment>
        )}
      </AppContainer>
      <ConfirmationModal
        header="Confirmation!"
        body="Are you sure you want to cancel?"
        isOpen={confirmationModalOpen}
        onYes={goToAnotherPage}
        onNo={confirmationModal}
      />

      <DAaddPartnerModal
        isOpen={addPartnerModalOpen}
        toggle={() => toggleAddPartMdl()}
        rows={rows}
        allPartners={rows}
        setRows={setRows}
        isAdd={true}
      />

      <TermsAndConditionModal isOpen={termsModalOpen} toggle={TermsModal} />
    </Form>
  );
};

export default DADspRegister;
